module.exports = __webpack_public_path__ + "static/media/AC_DC121.03c4e1e6.png";